import React, { useEffect } from 'react';
import { ISourceStore } from '@stores/source';
import classes from './sourceSetup.module.scss';
import { Card } from '@ui-library/card';
import isFeatureEnabled, { Feature } from '@utils/enableFeature';
import { useHistory } from 'react-router-dom';
import { Path } from '@components/routes';
import { PAGES } from '@components/profile/constants';
import { getSourceSetupLink } from '../utils';
import eventStreamSdks, { ICodeSnippet } from './constants/eventStreams';
import SdkSetup from './sdkSetup';
import NonSdkSetup from './nonSdkSetup';
import LocalStorage from '@utils/localStorage';

const SourceSetup = ({ source }: { source: ISourceStore }) => {
  const history = useHistory();
  const isEnabled = isFeatureEnabled();
  const goToGuide = () => {
    const docsURL = getSourceSetupLink(source?.sourceDef?.name);
    window.open(docsURL, '_blank');
  };
  const goToTeammates = () => {
    const enableNewSettings = isEnabled(Feature.enableNewSettings);
    if (enableNewSettings) {
      history.push(Path.SETTINGS, { tab: PAGES.MEMBERS });
      return;
    }
    history.push(Path.SETTINGS, { tab: PAGES.TEAM });
  };

  useEffect(
    () => () => {
      const visitedSources = LocalStorage.get('visitedSources');
      if (visitedSources) {
        if (!visitedSources.includes(source.id)) {
          const updatedVisitedSources = JSON.parse(visitedSources);
          updatedVisitedSources.push(source.id);
          LocalStorage.set('visitedSources', JSON.stringify(updatedVisitedSources));
        }
      } else {
        LocalStorage.set('visitedSources', JSON.stringify([source.id]));
      }
    },
    [source.id],
  );
  const sdkDetails = eventStreamSdks.find(
    (sdk: { name: string; codeSnippets: ICodeSnippet[] }) =>
      sdk.name.toLowerCase() === source?.sourceDef?.displayName.toLowerCase(),
  );

  if (sdkDetails?.name) {
    return (
      <Card className={classes.setupContainer}>
        <SdkSetup
          codeSnippets={sdkDetails.codeSnippets}
          goToGuide={goToGuide}
          goToTeammates={goToTeammates}
          source={source}
        />
      </Card>
    );
  }
  return (
    <Card className={classes.setupContainer}>
      <NonSdkSetup goToGuide={goToGuide} goToTeammates={goToTeammates} source={source} />
    </Card>
  );
};

export default SourceSetup;
